import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function relatorioTop5AssuntoReducer(state = initialState.relatorioTop5Assunto, action){
    switch(action.type) {
        case types.RELAT_TOP5_ASSUNTO:
            
            return action.relatorioTop5Assunto;
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/reduces/relatorioTop5AssuntoReducer.js
 **/